import React, { Component } from 'react'

import TextWithFieldname from '../texts/TextWithFieldname';
import Dico from '../../helpers/Dico';
import ContMessageI18N from '../../containers/ContMessageI18N';

class TableRates extends Component {

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }
	render() {
		return (
			<TextWithFieldname fieldname={this.props.fieldname} developperView={this.props.developperView} complexChild={true}>
				<div className="row shadow rounded p-0 m-1 table-responsive">
					<table className="table table-light table-striped">
						<thead>
							<tr className='table-primary'>
								<th className='text-center'>
									{this.props.developperView && this.props.fieldname}
									{!this.props.developperView && this.props.title}
								</th>
								<th className='text-end'>
									{this.props.developperView && 'value'}
									{!this.props.developperView && this.getMessage('generics.rate.value')}
								</th>
								<th className='text-start'>
									{this.props.developperView && 'nature'}
									{!this.props.developperView && this.getMessage('generics.rate.nature')}
								</th>
							</tr>
						</thead>
						<tbody>
							{Object.keys(this.props.rates).map((amtKey, index) => (
								<tr key={index} >
									<td className='text-center'>
										{this.props.developperView && amtKey}
										{!this.props.developperView && this.getMessage(`${this.props.i18nPrefix}.${amtKey}`)}
									</td>
									{this.props.rates[amtKey] && <td className='text-end'>
										{this.props.developperView && this.props.rates[amtKey].value}
										{!this.props.developperView && Dico.getDoubleFormatted(this.props.rates[amtKey].value, this.props.context.countryCode, this.props.context.languageCode, 'percent')}
									</td>}
									{this.props.rates[amtKey] && this.props.rates[amtKey].nature && <td className='text-start'>
										{this.props.developperView && this.props.rates[amtKey].nature}
										{!this.props.developperView && this.getMessage(`generics.rate.nature.${this.props.rates[amtKey].nature}`)}
									</td>}
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</TextWithFieldname>
		)
	}
}

export default (TableRates)
